import React from 'react';
import { withTranslation } from '../../lib/translate';
import Layout from '../../components/layout';
import { connect } from 'react-redux';
import { IonButton, IonIcon } from '@ionic/react';
import { forwardTo } from '../../lib/utils';
import Basket from '../../lib/basket';
import { NormalText, SmallText, Spacer, StrongText, Title } from '../../components/common';
import moment from 'moment';
import { chevronForwardOutline } from 'ionicons/icons';
import { getSentGiftVouchers } from '../../store/actions';
import './index.css';
import { ReactComponent as NoLoyaltyIcon } from '../../assets/images/no-data-loyalty-icon.svg';

class SentGiftVouchers extends React.Component {
	componentDidMount() {
		if (this.props.auth.loggedIn) {
			this.props.dispatch(getSentGiftVouchers());
		}
	}

	getVoucherDate = (voucher) => `${moment(voucher.send_on_date).format('LLLL')}${voucher.send_on_time ? ` ${this.props.__('at')} ${moment(voucher.send_on_time, 'HH:mm').format('LT')}` : ''}`;

	renderVoucher = (voucher) => {
		const amount = voucher.points_value / 100;
		return (
			<div
				key={voucher.id}
				className="box-content flex-wrapper flex-align-center pointer sent-gift-vouchers-item"
				onClick={() => forwardTo('/gift-vouchers', { voucher, isSent: true, hasEdit: !voucher.redeemed_on })}
			>
				<div className="flex-wrapper flex-align-center flex-justify-center sent-gift-vouchers-amount">
					<StrongText>{Basket.formatPrice(amount, false, !Number.isInteger(amount))}</StrongText>
				</div>
				<div className="sent-gift-vouchers-details">
					<StrongText className="block ellipsis">{voucher.recipient_first_name || voucher.recipient_email}</StrongText>
					<SmallText className="block ellipsis">{this.getVoucherDate(voucher)}</SmallText>
				</div>
				<IonIcon icon={chevronForwardOutline} />
			</div>
		);
	};

	render() {
		const { __, sentGiftVouchers } = this.props;
		const vouchers = [...sentGiftVouchers].sort((a, b) => moment(b.send_on_date) - moment(a.send_on_date) || b.id - a.id);
		return (
			<Layout showHamburger headerWithTitle title={__('Sent vouchers')} color="transparent">
				<div className="absolute-content scrollable-y flex-row-wrapper box-with-shadow">
					{sentGiftVouchers.length > 0 ? (
						<div>
							<Title className="web-only page-title-centered">{__('Sent vouchers')}</Title>
							{vouchers.map(this.renderVoucher)}
						</div>
					) : (
						<div>
							<div className="no-data-history centered">
								<NoLoyaltyIcon />
								<Spacer size={1} />
								<Title>{__('No Vouchers Yet')}</Title>
								<Spacer size={1} />
								<NormalText>{__('Your sent vouchers will appear here as soon as you send one')}</NormalText>
							</div>
						</div>
					)}
					<div className="flex-min">
						<Spacer size={5} />
						<IonButton className="button-uppercase" color="primary" expand="block" onClick={() => forwardTo('/gift-vouchers')}>
							{__('Send another gift voucher')}
						</IonButton>
					</div>
				</div>
			</Layout>
		);
	}
}

const stateToProps = (state) => {
	return {
		sentGiftVouchers: state.orders.sentGiftVouchers || [],
		auth: state.profile.auth,
	};
};
export default connect(stateToProps)(withTranslation(SentGiftVouchers));
